import { memo, FC } from "react";
import { EducationMaterial } from "../../types/education-materials/education-material";
import Carousel, { CarouselProps } from "react-multi-carousel";
import { EducationMaterialListItem } from "./education-materials-list-item";

interface EducationMaterialsListProps {
  materials: Array<EducationMaterial>;
  readonly?: boolean;
  carouselProps: CarouselProps;
}

export const EducationMaterialsList: FC<EducationMaterialsListProps> = memo(
  ({ materials, readonly, carouselProps }) => {
    return (
      <Carousel
        {...carouselProps}
      >
        {materials.map((material) => (
          <EducationMaterialListItem  readonly={readonly} key={material._id} material={material} />
        ))}
      </Carousel>
    );
  }
);
